import Chip from "@common/components/Chips";
import Typography from "@common/components/Typography";
import { displayDateTime } from "@common/utils/localTime.utils";
import { Divider, Paper } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Priority } from "@services/common/types";
import { Ticket } from "@services/tickets/types";
import React, { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

type TicketCardProps = {
  ticket: Ticket;
};

const Label = (props: { label: string; value?: any }) => (
  <Grid container direction="column" sx={{ width: '100%' }}>
    <Typography sx={{ color: "gray" }} size="smaller">
      {props.label}
    </Typography>
    <Typography sx={{ color: "white" }} size="smaller">
      {props.value}
    </Typography>
  </Grid>
);

const TicketCard = (props: PropsWithChildren<TicketCardProps>) => {
  const { ticket } = props;
  const { t } = useTranslation();

  return (
    <Paper sx={{ width: "100%", padding: 1 }}>
      <Grid
        container
        direction="column"
        sx={{ width: '100%', gap: 1, }}
      >
        <Grid
          container
          direction="row"
          wrap="nowrap"
          sx={{ width: '100%', justifyContent: "space-between",
            alignItems: "center",
            gap: 3, }}>
          <Chip color={ticket.priority} label={ticket.id} />
          <Label label={t("Status")} value={ticket.status} />
          <Grid size="auto">
            <Label
              label={t("Created on")}
              value={displayDateTime(ticket.openDate)}
            />
          </Grid>
        </Grid>
        <Divider orientation="horizontal" />
        <Grid>
          <Label label={t("Issue")} value={ticket.issue?.issue} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TicketCard;
